import { useState } from 'react';

import { buildNavPath as buildNavPathHelper } from 'helpers/candidate_application/form-page-helpers';
import { getSectionIcon } from 'helpers/iconsHelper';
import { useQueryParams } from 'hooks/query-params';
import { AnimatePresence } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomButton } from 'views/CandidateApp/components/CustomButton/CustomButton';

import { IconComponent } from 'components/Icon/IconComponent';
import SliderSideMotion from 'components/Motion/SliderSideMotion';

import { selectCandidateApplication } from 'api/candidate-application-slice';

const SectionIndexPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { token, sectionKey } = useParams();
  const [admin] = useQueryParams(['admin']);
  const {
    application: { brand },
  } = useSelector(selectCandidateApplication);

  const [isBackward, setIsBackward] = useState(false);

  // Helper to build navigation path with admin parameter preserved
  const buildNavPath = path => buildNavPathHelper(path, admin);

  // Get section translations
  const sectionTranslations = t(`${sectionKey}`, { ns: 'candidate_fields', returnObjects: true });
  const title = sectionTranslations?.title;
  const description = sectionTranslations?.description;

  // Navigation handlers
  const handleBackToDashboard = () => {
    setIsBackward(true);
    navigate(buildNavPath(`/form_submission/candidate/dashboard/${token}`));
  };

  const handleStartSection = () => {
    setIsBackward(false);
    // Navigate to first page after index page (always page 1 since this IS the index page)
    navigate(buildNavPath(`/form_submission/candidate/${sectionKey}/${token}/page/1`));
  };

  return (
    <AnimatePresence mode="wait">
      <SliderSideMotion
        key={`_index_${sectionKey}`}
        isBackward={isBackward}
        delay={0.1}
        className="d-flex flex-column u-gap-large">
        <div className="d-flex flex-column align-items-start u-gap-large u-margin-bottom--large">
          <IconComponent icon={getSectionIcon(sectionKey)} size="xxlarge" />
          <div className="d-flex flex-column align-items-start u-gap-large">
            <h1 className="primary-text u-font-weight-500 u-margin-0 text-5xl">{title}</h1>
            {description && (
              <p className="secondary-text u-font-size-medium font-light">{description}</p>
            )}
          </div>
          <div className="d-flex flex-row justify-content-between u-width-100 u-gap-large">
            <CustomButton type="secondary" onClick={handleBackToDashboard}>
              Back
            </CustomButton>
            <CustomButton
              brand={brand}
              dataTestId="get-started-button"
              onClick={handleStartSection}>
              Get Started
            </CustomButton>
          </div>
        </div>
      </SliderSideMotion>
    </AnimatePresence>
  );
};

export default SectionIndexPage;
